export default __webpack_public_path__ + "static/assets/6bc3585d97c0d5b3ce3f9117d083e162.png";